import { ReactNode } from 'react';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

interface Props {
    title: string;
    description: ReactNode;
}

export const AppointmentDetailsRow = ({ title, description }: Props) => (
    <Grid container>
        <Grid item xs={4} lg={3}>
            <Typography fontWeight={500}>{title}</Typography>
        </Grid>
        <Grid item xs={8} lg={9}>
            {typeof description === 'string' ? <Typography>{description}</Typography> : description}
        </Grid>
    </Grid>
);
